<script setup lang="ts">
	import type { NavigationItem } from './Main.vue'

	const $props = defineProps<{
		items: Array<NavigationItem>,
		footerItems?: Array<NavigationItem[]>,
	}>()
</script>

<template>
	<nav role="navigation">
		<ul v-if="items && items.length" class="divide-y divide-black/50">
			<li class="[&>a]:hover:text-red">
				<NuxtLink class="font-bold text-xl text-red hover:!text-green block px-2 py-2 xs:py-3 sm:py-4 transition duration-300 ease-in-out" no-prefetch title="zur Startseite" :to="{name: 'home'}">
					Startseite
				</NuxtLink>
			</li>
			<li v-for="(item,idx) in items" :key="idx" class="[&>a]:hover:text-red">
				<NuxtLink :title="`zur Seite ${item.label}`" :to="{name: item.name, params: item.slug ? { article_slug: item.slug } : {}}" class="font-bold text-xl text-red hover:!text-green block px-2 py-2 xs:py-3 sm:py-4 transition duration-300 ease-in-out" no-prefetch>
					{{ item.label }}
				</NuxtLink>
			</li>
			<li v-for="(item,idx) in footerItems" :key="idx" class="[&>a]:hover:text-red">
				<NuxtLink v-if="item.slug"
						  :title="`zur Seite ${item.label}`"
						  :to="{name: item.name, params: item.slug ? { article_slug: item.slug } : {}}" class="font-bold text-xl block hover:!text-blue px-2 py-2 xs:py-3 sm:py-4 transition duration-300 ease-in-out"
						  no-prefetch>
					{{ item.label }}
				</NuxtLink>
			</li>
		</ul>
	</nav>
</template>
